import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    knowledgeFileData: {},
  },
  getters: {
    knowledgeFileData: (state) => state.knowledgeFileData,
  },
  actions: {
    loadKnowledgeFileList(context, { size, type, after }) {
      return new Promise((resolve, reject) => {
        alice.getKnowledgeFileList(size, type, after)
          .then((response) => {
            context.commit('setKnowledgeFileList', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteKnowledgeFile(context, params) {
      const { id, fileType } = params;
      return new Promise((resolve, reject) => {
        alice.deleteKnowledgeFile(id, fileType)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    clearLocalKnowledgeFileList(context) {
      context.commit('setKnowledgeFileList', []);
    },
  },
  mutations: {
    setKnowledgeFileList(state, data) {
      Vue.set(state, 'knowledgeFileData', data);
    }
  }
};
